export { default as pdf } from "./pdf.png";
export { default as doc } from "./doc.png";
export { default as none } from "./none.png";
export { default as xls } from "./xls.png";
export { default as jpg } from "./Asset 5.png";
export { default as pptx } from "./pptx.png";
export { default as zip } from "./zip.png";



// WEBPACK FOOTER //
// ./src/images/FileTypes/index.js